module.exports = __webpack_public_path__ + "img/GENERAL-BALENO-3.6d41a043.jpg";